module.exports = __webpack_public_path__ + "static/img/download.edb7388.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download.png
// module id = 0SEy
// module chunks = 1